import { createFileRoute, Link } from "@tanstack/react-router";
import { ChevronLeft } from "lucide-react";
import { apiQuery, useApiSuspenseQuery } from "@/client/lib/api";
import { ensurePage, pageHead } from "@/client/lib/page";
import Loading from "@/client/modules/pacientes/detalhe/loading";
import { PatientDetailClient } from "@/client/modules/pacientes/detalhe/patient-detail-client";
import { PatientRemindersSection } from "@/client/modules/pacientes/patient-reminders-section";

type Search = { tab?: string };

export const Route = createFileRoute("/app/pacientes/$id/")({
  validateSearch: (s: Record<string, unknown>): Search => ({ tab: s.tab as string | undefined }),
  loaderDeps: ({ search }) => search,
  loader: ({ context, params, deps }) =>
    ensurePage(context.queryClient, apiQuery("pacientes", "detailPage", { id: params.id, tab: deps.tab })),
  head: () => pageHead("Paciente"),
  pendingComponent: Loading,
  component: PacientePage,
});

function PacientePage() {
  const { id } = Route.useParams();
  const { tab } = Route.useSearch();
  const { data } = useApiSuspenseQuery("pacientes", "detailPage", { id, tab });
  const { reminders, ...props } = data;
  return (
    <div className="mx-auto flex max-w-7xl flex-col gap-4">
      <div>
        <Link
          to="/app/pacientes"
          className="inline-flex items-center gap-1 text-xs text-slate-500 transition hover:text-slate-800"
        >
          <ChevronLeft className="h-3 w-3" /> Pacientes
        </Link>
      </div>
      <PatientRemindersSection patientId={data.patient.id} patientName={data.patient.fullName} reminders={reminders} />
      <PatientDetailClient {...props} />
    </div>
  );
}
